// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__zEZv1","tabLabelSelected":"Tabs_tabLabelSelected__8x8n+","tabLabelUnselected":"Tabs_tabLabelUnselected__kaAyG"};